export default __webpack_public_path__ + "static/pop-ai-940349c63f0b4c37c877c305d7733bc2049d121721c74899314a5e48b3a6d124.png";